import { TableCell, TableRow } from "@/components/ui/table";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { getStatusColor } from "../utils/statusColors";
import { toast } from "sonner";
import { useCartStore } from "@/stores/newCartStore";

interface StockTableRowProps {
  item: any;
  quantity: number;
  onQuantityChange: (value: string) => void;
  onAddToCart: (item: any, quantity: number) => void;
  onRestock: () => void;
  onReturn?: () => void;
  buttonVisibility: {
    cart: boolean;
    restock: boolean;
    return: boolean;
    quantity: boolean;
    actions: boolean;
  };
  formatPrice: (price: string | number) => string;
}

export const StockTableRow = ({
  item,
  quantity,
  onQuantityChange,
  onAddToCart,
  onRestock,
  onReturn,
  buttonVisibility,
  formatPrice,
}: StockTableRowProps) => {
  const { addItem } = useCartStore();

  const handleAddToCart = async () => {
    try {
      if (quantity <= 0) {
        toast.error("La quantité doit être supérieure à 0");
        return;
      }

      if (quantity > (item.quantity || 0)) {
        toast.error("Quantité insuffisante en stock");
        return;
      }

      await addItem(item.id, quantity);
      onAddToCart(item, quantity);
    } catch (error) {
      console.error("Erreur lors de l'ajout au panier:", error);
      toast.error("Erreur lors de l'ajout au panier");
    }
  };

  const price = item?.data?.price || 0;
  const name = item?.data?.name || 'N/A';
  const unit = item?.data?.unit || 'Pièce';
  const status = item?.data?.status || 'En stock';

  return (
    <TableRow className="hover:bg-siby-50/50">
      <TableCell className="font-medium whitespace-nowrap">{name}</TableCell>
      <TableCell className="whitespace-nowrap">{item.quantity || 0}</TableCell>
      <TableCell className="whitespace-nowrap">{unit}</TableCell>
      <TableCell className="whitespace-nowrap">{formatPrice(price)}</TableCell>
      <TableCell className="whitespace-nowrap">
        <span className={`px-2 py-1 rounded-full text-sm ${getStatusColor(status)}`}>
          {status}
        </span>
      </TableCell>
      {buttonVisibility.actions && (
        <TableCell>
          <div className="flex flex-wrap gap-2 items-center justify-end">
            {buttonVisibility.quantity && (
              <Input
                type="number"
                min="1"
                max={item.quantity || 0}
                value={quantity}
                onChange={(e) => onQuantityChange(e.target.value)}
                className="w-20 border-siby-200 focus:ring-siby-500"
              />
            )}
            {buttonVisibility.cart && (
              <Button
                variant="ghost"
                size="sm"
                className="text-siby-600 hover:text-siby-700 hover:bg-siby-50 whitespace-nowrap"
                onClick={handleAddToCart}
                disabled={!item.quantity || item.quantity === 0 || quantity > item.quantity}
              >
                Ajouter au panier
              </Button>
            )}
            {buttonVisibility.restock && (
              <Button
                variant="ghost"
                size="sm"
                className="text-siby-600 hover:text-siby-700 hover:bg-siby-50 whitespace-nowrap"
                onClick={onRestock}
              >
                Réapprovisionner
              </Button>
            )}
            {buttonVisibility.return && onReturn && (
              <Button
                variant="ghost"
                size="sm"
                className="text-orange-600 hover:text-orange-700 hover:bg-orange-50 whitespace-nowrap"
                onClick={onReturn}
              >
                Retour
              </Button>
            )}
          </div>
        </TableCell>
      )}
    </TableRow>
  );
};